import {createUseStyles} from 'react-jss';

export default createUseStyles({
  overlay: {
    fontSize: 14,
  },
  buttonContainer: {
    marginTop: 40,
  },
});
